<template>
  <div class="goal-card pb-5">
    <div class="d-flex align-items-center goal-skeleton">
      <div class="avatar rounded-circle shine"></div>
      <div class="title shine col-8"></div>
    </div>
    <div class="krs pl-4 pt-4">
      <div class="d-flex align-items-center kr-skeleton">
        <div class="avatar rounded-circle shine"></div>
        <div class="title shine col-8"></div>
      </div>
      <div class="d-flex align-items-center kr-skeleton mt-1">
        <div class="avatar rounded-circle shine"></div>
        <div class="title shine col-8"></div>
      </div>
      <div class="d-flex align-items-center kr-skeleton mt-1">
        <div class="avatar rounded-circle shine"></div>
        <div class="title shine col-8"></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * This is skeleton loader for Goal
 */
export default {
  name: 'Goal'
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.goal-skeleton {
  height: 30px;
}

.kr-skeleton {
  height: 37px;
}

.avatar {
  height: 26px;
  width: 26px;
  margin-right: 12px;
}

.title {
  height: 26px;
  border-radius: 10px;
}

$gutterSpace: 56px;

.goal-card {
  padding: 30px $gutterSpace 30px $gutterSpace;
  border-radius: 10px;
  box-shadow: $cardShadow;
}
</style>
